<template>
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      :width="1200"
      ok-text="确认"
      cancel-text="取消"
      @ok="ok"
      @cancel="cancel"
    >
      <a-form :form="form" v-bind="formLayout">

        <a-row>
          <a-col :span="12">
            <a-form-item label="账户">
              <a-select
                option-filter-prop="children"
                show-search
                v-decorator="[
                  'userId',
                  { rules: [{ required: true, message: '请选择账户' }] },
                ]"
                @select="userListSelect"
              >
                <a-select-option
                  v-for="item in userDataList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="资源库">
              <a-select
                option-filter-prop="children"
                show-search
                v-decorator="[
                  'resourceId',
                  { rules: [{ required: true, message: '请选择资源' }] },
                ]"
              >
                <a-select-option
                  v-for="item in tempResourceDataList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row>
          <a-col :span="12">
            <a-form-item label="算法模型">
              <a-select
                option-filter-prop="children"
                show-search
                v-decorator="[
                  'modelId',
                  { rules: [{ required: true, message: '请选择算法模型' }] },
                ]"
              >
                <a-select-option
                  v-for="item in tempModelDataList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <a-form-item label="训练次数">
              <a-input
                v-decorator="[
                  'trainCount',
                  { rules: [{ required: true, message: '请填写训练次数' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="训练阈值">
              <a-input
                v-decorator="[
                  'trainThreshold',
                  { rules: [{ required: true, message: '请填写训练阈值' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        
        <a-row>
          <a-col :span="12">
            <a-form-item label="类别数">
              <a-input
                v-decorator="[
                  'numClass',
                  { rules: [{ required: true, message: '请输入类别数' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="批处理量">
              <a-input v-decorator="['cbatchSize',{ rules: [{ required: true, message: '请输入批处理量' }] },]" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <a-form-item label="图像高度">
              <a-input v-decorator="['imageHeight',{ rules: [{ required: true, message: '请输入图像高度' }] },]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="图像宽度">
              <a-input v-decorator="['imageWidth',{ rules: [{ required: true, message: '请输入图像宽度' }] },]" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <a-form-item label="旋转增强">
              <a-select v-decorator="['rotateAugmentation',{ rules: [{ required: true, message: '请选择旋转增强' }] },]">
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="颜色增强">
              <a-select v-decorator="['colourAugmentation',{ rules: [{ required: true, message: '请选择颜色增强' }] },]">
                <a-select-option :key="0" :value="0"> 否 </a-select-option>
                <a-select-option :key="1" :value="1"> 是 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
  
  <script>
import { requestUrl } from "@utils/request_url";
import request from "@utils/request";
import pick from "lodash.pick";
import { getResourceListApi } from "@api/semi_management";
const fields = ["userId", "resourceId", "trainCount", "trainThreshold","numClass","cbatchSize","imageHeight","imageWidth","rotateAugmentation","colourAugmentation","modelId"];
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    userDataList: {
      type: Array,
      required: true,
    },

    resourceDataList: {
      type: Array,
      required: true,
    },

    modelDataList:{
      type: Array,
      required: true,
    },

    model: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };
    return {
      form: this.$form.createForm(this),
      selectUserId: "",
      tempModelDataList:this.modelDataList,
      tempResourceDataList: this.resourceDataList,
      tempResourceId: this.resourceId,
    };
  },
  created() {},
  mounted() {
    this.$watch("model", () => {
      console.log(JSON.stringify(this.model));
      this.$nextTick(() => {
        this.model && this.form.setFieldsValue(pick(this.model, fields));
      });
    });
  },
  methods: {
    userListSelect(value, option) {
      const that = this;
      getResourceListApi({ userId: value }).then((res) => {
        that.tempResourceDataList = res.data;
        if (that.model.resourceId == null) {
          //that.model.resourceId=that.tempResourceDataList[0].id;
          if (that.tempResourceDataList != null &&that.tempResourceDataList.length > 0){
              that.form.setFieldsValue({
                resourceId: that.tempResourceDataList[0].id,
              });
          }else{
               that.form.setFieldsValue({resourceId: "",});
          }
        }
      });
    },
    ok() {
      const that = this;
      this.form.validateFields((error, values) => {
        if (!error) {
          var commitValue = {
            userId: values.userId,
            resourceId: values.resourceId,
            trainCount:values.trainCount,
            trainThreshold:values.trainThreshold,
            numClass:values.numClass,
            imageHeight:values.imageHeight,
            imageWidth:values.imageWidth,
            cbatchSize:values.cbatchSize,
            rotateAugmentation:values.rotateAugmentation,
            colourAugmentation:values.colourAugmentation,
            modelId:values.modelId
          };
          this.$emit("ok", commitValue);
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
   
  },
  watch: {
    visible(newv, oldv) {},
    resourceDataList(newv, oldv){
       this.tempResourceDataList=newv;
      //  if(this.model&&this.form){
      //   this.$nextTick(()=>{
      //     this.form.setFieldsValue({resourceId:this.model.resourceId});
      //   })
      
      
      //  }
        
    }
   
  },
};
</script>
  
  <style lang="scss" scoped>
</style>